import keycloak from '../keycloak';
import {isLocalAuthBypassEnabled} from '../config/mockAuth';

// Returns a fresh access token, or null in bypass mode (the agent interceptor
// will send ADFS_LOGIN + DEBUG_ROLES instead). Mirrors hse-skeleton-app's
// agent/keycloakAuth.ts.
export async function getAccessToken(): Promise<string | null> {
    if (isLocalAuthBypassEnabled()) {
        return null;
    }
    try {
        await keycloak.updateToken(30);
        return keycloak.token ?? null;
    } catch {
        keycloak.login({scope: 'openid'});
        return null;
    }
}
